module.exports = __webpack_public_path__ + "static/media/sell_return.321aa0e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/sell_return.svg
// module id = 416
// module chunks = 0